"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ENS_NAME_SEPARATOR = '.';